import { motion } from 'framer-motion';
import styled from 'styled-components';

import { ReactComponent as ArrowUpSvg } from '../../../icons/arrow-up.svg';

export const Wrapper = styled(motion.div)`
    position: sticky;
    top: 30px;
    left: 0;
    width: 100%;
    z-index: 2;

    display: flex;
    align-items: center;
    justify-content: center;

    pointer-events: none;
`;

export const Button = styled.button`
    background: linear-gradient(300.86deg, #523df1 39.32%, #976af6 92.76%);
    background-size: 200% 200%;
    background-position: center;

    border-radius: 40px;

    height: 32px;
    padding: 0 14px;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 5px;

    color: #fff;
    font-weight: 700;
    font-size: 12px;
    line-height: 100%;
    text-align: center;
    letter-spacing: -0.02em;

    border: none;
    pointer-events: all;
    cursor: pointer;

    transition:
        background-position 0.2s ease-in-out,
        box-shadow 0.2s ease-in-out;

    &:hover {
        background-position: right;
        box-shadow:
            0 0 68px 0 rgb(255 255 255 / 10%) inset,
            0 0 0 1px rgb(255 255 255 / 10%) inset;
    }
`;

export const Icon = styled(ArrowUpSvg)`
    width: 8px;
    height: 8px;
`;
